import React, { useEffect, useState } from 'react';
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowRight } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';

import styles from '../styles/userDetailDialog';
import {
  isArray,
  isBoolean,
  isDefined,
  isUndefined,
  isObject,
  isStringEmpty
} from '../../../utils/isDefined';

const UserDetailsTable = ({ data, classes, expandSignal }) => {
  if (isUndefined(data) || !isObject(data)) {
    return null;
  }

  return (
    <Table size="small" className={classes.table}>
      <TableBody>
        {Object.keys(data).map(key => {
          const value = data[key];
          const label = key;

          if (isObject(value)) {
            return (
              <ExpandableRow
                key={key}
                label={label}
                classes={classes}
                expandSignal={expandSignal}
              >
                <UserDetailsTable
                  data={value}
                  classes={classes}
                  expandSignal={expandSignal}
                />
              </ExpandableRow>
            );
          }

          if (isArray(value) && value.some(isObject)) {
            return (
              <ExpandableRow
                key={key}
                label={label}
                classes={classes}
                expandSignal={expandSignal}
              >
                <ArrayItemsTable
                  items={value}
                  classes={classes}
                  expandSignal={expandSignal}
                />
              </ExpandableRow>
            );
          }

          return (
            <TableRow key={key}>
              <TableCell className={classes.labelCell}>{label}</TableCell>
              <TableCell className={classes.valueCell}>
                {formatValue(value)}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default withStyles(styles)(UserDetailsTable);

const ExpandableRow = ({ label, classes, children, expandSignal }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isDefined(expandSignal)) {
      setOpen(expandSignal.open);
    }
  }, [expandSignal]);

  return (
    <>
      <TableRow>
        <TableCell className={classes.labelCell}>
          <IconButton
            size="small"
            className={classes.expandIcon}
            onClick={() => setOpen(prevOpen => !prevOpen)}
          >
            {open ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
          </IconButton>
          {label}
        </TableCell>
        <TableCell className={classes.valueCell} />
      </TableRow>
      <TableRow>
        <TableCell className={classes.collapseCell} colSpan={2}>
          <Collapse in={open} unmountOnExit>
            {children}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const ArrayItemsTable = ({ items, classes, expandSignal }) => (
  <Table size="small" className={classes.table}>
    <TableBody>
      {items.map((item, index) => (
        <ExpandableRow
          key={index}
          label={`#${index + 1}`}
          classes={classes}
          expandSignal={expandSignal}
        >
          <UserDetailsTable
            data={item}
            classes={classes}
            expandSignal={expandSignal}
          />
        </ExpandableRow>
      ))}
    </TableBody>
  </Table>
);

const labelFromKey = key =>
  key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/^./, char => char.toUpperCase());

const formatValue = value => {
  if (isUndefined(value) || isStringEmpty(value)) {
    return '-';
  }
  if (isBoolean(value)) {
    return value.toString();
  }
  if (isArray(value)) {
    return value.length ? value.join(', ') : '-';
  }
  return value;
};
